<template>
  <div id="contactUs"> 
    <Navigation/>
    <div class="container-fluid container_fluid">
      <div class="row fluid_row">
        <div class="col-md-12 _Modular">
            <div class="right_border"></div>
            <div class="col-md-12 right_cont_title">联系我们</div>
            <div class="col-md-12 right_cont_slogan">合作咨询商业洽谈</div>
            <div class="col-md-8 information">
                <span><i class="iconfont icondizhi"></i> 地址：上海市莘建东路58弄绿地科技岛A座907室</span>
                <!-- <span><i class="iconfont iconyouxiang"></i> 邮箱：service@qisuxinxi.com</span> -->
            </div>  

            <div class="col-md-8 contact_QRCode">
                <span> 微信公众号：汉方颐养</span>
                <img src="../../static/image/PublicCode.jpg" class="Public_addressImage">
            </div> 
        </div>
      </div>
      <div class="col-md-12 bottom_dv">
          <span>Copyright © 2016 上海岐素信息科技有限公司.All rights reserved.</span>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from './publicComponent/Navigation'
export default {
  data(){
    return{

    }
  },
  created(){
  },
  methods:{
  },
  components: {
    "Navigation":navigation
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (min-width: 750px){
    .fluid_row{
      margin-top: 11vh !important;
    }
    ._Modular{
      position: relative;
    }
    .right_border{
      width: 12vw;
      height: 7vw;
      position: absolute;
      border: 10px solid #ebeced;
      left: 23%;
      top: 2.2vw;
    }
    .right_cont_title{
      font-size: 2.5vw;
      color: #0047ab;
      padding-left: 18% !important;
      padding-top: 3% !important;
      font-weight: 600;
    }
    .right_cont_slogan{
      font-size: 1.5vw;
      font-weight: 600;
      padding-left: 18.2% !important;
    }
    .information{
        background: #f4fbff;
        height: 10vw;
        margin-left: 18% !important;
        border-left: 8px solid #0047ab;
        margin-top: 3vw !important;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .information>span{
        font-size: 1vw;
        padding-left: 4% !important;
        padding-top: 1% !important;
    }
    .information>span i{
        font-size: 1vw;
    }
    .contact_QRCode{
        background: #f4fbff;
        height: 10vw;
        margin-left: 18% !important;
        border-left: 8px solid #0047ab;
        margin-top: 3vw !important;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .contact_QRCode>span{
        font-size: 1vw;
        padding-left: 4% !important;
    }
    .Public_addressImage{
        width: 6vw;
        margin-left: 4% !important;
        padding-top: 1% !important;
    }
    .bottom_dv{
        height: 4vw;
        background: #363d45;
        position: absolute;
        bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100% !important;
    }
    .bottom_dv>span{
        color: #fff;
    }
}

/* 移动端特殊样式 */
@media screen and (max-width: 750px){
}

</style>



// WEBPACK FOOTER //
// src/components/ContactUs.vue